<template>
  <div ref="wrapper" class="wrapper">
    <div class="overlay">made with <span>love</span> by <a href="http://davidgabathuler.ch">davidgabathuler.ch</a> </div>
    <div ref="display" class="display" @mousemove="move">
      <h1 id="one">delta ii</h1>
      <h1 id="two">vandenberg</h1>
      <h1 id="three">1985 — 2019</h1>
      <h1 id="four">iridium</h1>
      <h1 id="five">low earth orbit</h1>
      <h1 id="six">rokot/briz—km</h1>
      <h1 id="seven">35785 km</h1>
      <h1 id="eight">proton-k/dm2</h1>
      <div id="circle"></div>
      <div id="stick"></div>
    </div>
    <div class="download">
      <h3>Please note that the font is still in beta, I will update it eventually.<br>I released the font for free under the CC4.0 license. <br> If you use the font commercially, please consider a small tip. Thanks!</h3>
      <a class="download-link" href="/download/DGIridiumGX.zip" download>
        <div class="btn">download</div>
      </a>
      <link href="https://fonts.googleapis.com/css?family=Cookie" rel="stylesheet"><a class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/davidgabathuler"><img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"><span>Buy me a coffee</span></a>
      <p class="licence">
        <a rel="license" href="http://creativecommons.org/licenses/by/4.0/"><img alt="Creative Commons Lizenzvertrag" style="border-width:0" src="https://i.creativecommons.org/l/by/4.0/80x15.png" /></a><br /><span xmlns:dct="http://purl.org/dc/terms/" href="http://purl.org/dc/dcmitype/Dataset" property="dct:title" rel="dct:type">DG Iridium</span> von <a xmlns:cc="http://creativecommons.org/ns#" href="davidgabathuler.ch" property="cc:attributionName" rel="cc:attributionURL">David Gabathuler</a> ist lizenziert unter einer <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">Creative Commons Namensnennung 4.0 International Lizenz</a>.
      </p>
      <h4><a href="http://davidgabathuler.ch" target="_blank">davidgabathuler</a></h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Iridium',
  props: {
    msg: String
  },
  mounted(){
  },
  methods: {
    move(e){
      if(window.isMobile == false){
        let actualValWeight = 0;
        let actualValDistance = 0;
        let maxValH = 700 / this.$refs.display.clientWidth;
        actualValWeight = maxValH * e.clientX;
        let maxValW = 900 / this.$refs.display.clientHeight;
        actualValDistance = maxValW * e.clientY;
        let one = document.getElementById('one');
        one.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
        let two = document.getElementById('two');
        two.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
        let three = document.getElementById('three');
        three.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
        let four = document.getElementById('four');
        four.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
        let five = document.getElementById('five');
        five.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
        let six = document.getElementById('six');
        six.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
        let seven = document.getElementById('seven');
        seven.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
        let eight = document.getElementById('eight');
        eight.style.fontVariationSettings = "'wght' "+ actualValWeight +", 'wdth' "+ actualValDistance +""
      }
    }
  }
}
</script>
